/**
 * Language Context
 *
 * MIGRATED: This file now re-exports from the new i18n module.
 * The new i18n system provides:
 *   - Nested translation keys (e.g., 'dashboard.title')
 *   - Better TypeScript support
 *   - Easy addition of new languages
 *   - Template variable support (e.g., 'Hello {{name}}')
 *
 * All components should now use:
 *   import { useTranslation } from '../i18n';
 *   const { t } = useTranslation();
 *   t('dashboard.title')
 *
 * This file exists for backwards compatibility with any remaining imports.
 */

import React from 'react';
import {
  I18nProvider,
  useTranslation,
  SUPPORTED_LANGUAGES,
  DEFAULT_LANGUAGE
} from '../i18n';
import type { Language } from '../i18n';

// Re-export types and constants
export type { Language };
export { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE };

// ============================================================================
// Wrapper Provider (re-exports I18nProvider)
// ============================================================================

interface LanguageProviderProps {
  children: React.ReactNode;
}

export function LanguageProvider({ children }: LanguageProviderProps) {
  return <I18nProvider>{children}</I18nProvider>;
}

// ============================================================================
// Hook (re-exports useTranslation)
// ============================================================================

/**
 * @deprecated Use `import { useTranslation } from '../i18n'` instead
 */
export function useLanguage() {
  return useTranslation();
}
